import { useQuery } from "@apollo/client";
import { get } from "lodash";
import { GET_PDR_REQUIREMENTS_QUERY } from "@/pages/people/[pgaId]/education/queries";
import { DEFAULT_PDR_CYCLE_CODE } from "@/pages/people/[pgaId]/education/professional-development";
import { CycleRequirements } from "@/types";
import { buildPdrMetric } from "@/lib/pdrCardHelpers";
import { MetricCardType } from "@/components/MetricCard/MetricCard.types";
import { Path } from "@/router";

type PdrRequirementsData = {
  pdrRequirements: {
    cycleRequirements: CycleRequirements;
  };
};

const PDR_METRIC_PLACEHOLDER: MetricCardType<Path> = {
  label: "Professional Development",
  value: "",
  iconName: "school",
  loading: true
};

export function usePdrStatus(pgaId: string | undefined, options?: { skip?: boolean }) {
  const { data, loading } = useQuery<PdrRequirementsData>(GET_PDR_REQUIREMENTS_QUERY, {
    variables: { pgaId, cycleCode: DEFAULT_PDR_CYCLE_CODE },
    skip: !pgaId || options?.skip
  });

  const cycleRequirements = get(data, "pdrRequirements.cycleRequirements", undefined);
  const pdrMetric = cycleRequirements
    ? buildPdrMetric(cycleRequirements, pgaId)
    : loading
      ? PDR_METRIC_PLACEHOLDER
      : undefined;

  return { pdrMetric, cycleRequirements, loading };
}
